import { Img } from '@chakra-ui/react'
import React from 'react'
import "./centerBlog.css"

 const CBlog = () => {

    return (
      <div>
          <div className="Clog">
              <div className="Blog1">
                <div>
                <Img className="LBI" src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/lsci/db/PICTURES/CMS/344300/344383.6.jpg"/>
                </div>
                <div className="LBIT">
                  <h1>Kohli: 'I came to realise I awas trying to fake my intensity recently'</h1>
                  <p>Reading for a comeback against Pakistan on Sunday , Kohli says that he is "feeling light" sfter his break</p>
                </div>
                <div className="LBIBP" style={{paddingLeft:"10px"}}>
                  <div className="LBIBPIMG">
                     <Img className="DV" src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_720/esci/media/motion/2022/0827/dm_220827_INET_CRIC_asiacup_kohli-pkg_nonbranded_global/dm_220827_INET_CRIC_asiacup_kohli-pkg_nonbranded_global.jpg"/>
                  </div>
                      <div>
                      <p><b>'Your mind is telling you to step back'</b></p>
                      <p>The India batter tells <b>Star Sports</b> he was feeling mentally down before taking a break</p>
                      </div>
                </div>
              </div>
              <br  />
              <div className="Blog2">
                <div className="Blog21">
                 <div className="Blog211">
                  <p className="Blog21p1"><b>ENGLAND VS SOUTH AFRICA </b></p>
                  <p className="Blog21p2"> 2ND MEN'S TEST , OLD TRAFFORD</p>
                 </div>
                  <p style={{"color":"red","fontSize":"12px","fontWeight":"700","margin":"0px","paddingLeft":"5px"}}>LIVE</p>
                  <p style={{"margin":"0px","marginBottom":"0px","paddingLeft":"5px"}}>SA  <b style={{"color":"red","margin":"0px","marginBottom":"0px"}}>.</b></p>
                  <p style={{"margin":"0px","paddingLeft":"5px"}}>ENG</p>
                  <p style={{"fontSize":"12px","fontWeight":"400","paddingLeft":"5px"}}>Day 3 - session 3: South Africa trail by 96 runs</p>
                </div>
                <div>
                <Img style={{"margin":"10px" ,"width":"95%","borderRadius":"10px"}} src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_320/lsci/db/PICTURES/CMS/344800/344837.6.jpg"/>
                  <p style={{"margin":"0px","paddingLeft":"5px"}}><b>Live - Peterson, van der Dussen solid seamers strike early</b></p>
                </div>
                <div className="LBIBP">
                  <div className="LBIBPIMG">
                     <Img className="DV" src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_240/lsci/db/PICTURES/CMS/344800/344831.6.jpg"/>
                     <p style={{"color":"#2b2c2b","fontSize":"14px","fontWeight":"500","margin":"0px","paddingLeft":"5px"}}>Lunch report - Anderson, Robinson and Broad run through top order</p>
                  </div>
                  <div className="LBIBPIMG">
                     <Img className="DV" src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_240/lsci/db/PICTURES/CMS/344800/344801.6.jpg"/>
                     <p style={{"color":"#2b2c2b","fontSize":"14px","fontWeight":"500","margin":"0px","paddingLeft":"5px"}}>Spin strategy allows game to drift as SA lose grip</p>
                  </div>
                  <div className="LBIBPIMG">
                     <Img className="DV" src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_240/lsci/db/PICTURES/CMS/344700/344789.6.jpg"/>
                     <p style={{"color":"#2b2c2b","fontSize":"14px","fontWeight":"500","margin":"0px","paddingLeft":"5px"}}>Relif fro Foakers after timely ton reassures him of Test worth</p>
                  </div>
                </div>
              </div>
              <br  />
              <div className="Blog2">
                <div className="Blog21">
                  <div className="Blog211">
                   <p className="Blog21p1"><b>AFGANISTAN VS SRI LANKS </b></p>
                   <p className="Blog21p2"> ASIA CUS 2022, DUBAI</p>
                  </div>
                  <p style={{"color":"red","fontSize":"12px","fontWeight":"700","margin":"0px","paddingLeft":"5px"}}>LIVE</p>
                  <p style={{"margin":"0px","marginBottom":"0px","paddingLeft":"5px"}}>SL  <b style={{"color":"red","margin":"0px","marginBottom":"0px"}}>.</b></p>
                  <p style={{"margin":"0px","paddingLeft":"5px"}}>AFG</p>
                  <p style={{"fontSize":"12px","fontWeight":"400","paddingLeft":"5px"}}>Afganistan won by 8 wickets (with 59 runs remaining)</p>
                </div>
                <div>
                  <Img style={{"margin":"10px" ,"width":"95%","borderRadius":"10px"}} src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_320/lsci/db/PICTURES/CMS/344800/344843.6.jpg"/>
                  <p style={{"margin":"0px","paddingLeft":"5px"}}><b>Farooqi and spinners set up Afganistan's route of Sri Lanka</b></p>
                  <p style={{"margin":"0px","paddingLeft":"5px"}}>Gurbaz and Zazai racked up 83 runs , out of a target of 106, in the powerplay itself</p>
                </div>
                
              </div>
              <br/>
              <div className="Blog2">
                <div className="Blog21">
                 <div className="Blog211">
                  <p className="Blog21p1"><b>ENGLAND VS SOUTH AFRICA </b></p>
                  <p className="Blog21p2"> 2ND MEN'S TEST , OLD TRAFFORD</p>
                 </div>
                 
                </div>
                <div>
                <Img style={{"margin":"10px" ,"width":"95%","borderRadius":"10px"}} src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_320/esci/media/motion/2022/0827/dm_220827_COM_CRIC_Analysis_PoliteEnquiries_Does_this_Test_qualify_for_Bazball_or_Benball_220827/dm_220827_COM_CRIC_Analysis_PoliteEnquiries_Does_this_Test_qualify_for_Bazball_or_Benball_220827.jpg"/>
                  <p style={{"margin":"0px","paddingLeft":"5px"}}><b>Live - Peterson, van der Dussen solid seamers strike early</b></p>
                </div>
                <div className="LBIBP">
                  <div className="LBIBPIMG">
                     <Img className="DV" src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_square_w_320/lsci/db/PICTURES/CMS/344800/344835.10.jpg"/>
                  </div>
                      <div>
                      <p><b>Strokes steal the show in another box office display</b></p>
                      <p>Capton has never been at ease with himself , says<b>Vithanshan Etharanjasnh</b></p>
                      </div>
                </div>
                <div className="LBIBP">
                  <div className="LBIBPIMG">
                     <Img className="DV" src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_240/lsci/db/PICTURES/CMS/344800/344806.6.jpg"/>
                     <p style={{"color":"#2b2c2b","fontSize":"14px","fontWeight":"500","margin":"0px","paddingLeft":"5px"}}>Strokes then foakes , put Engkland out of reach</p>
                  </div>
                  <div className="LBIBPIMG">
                     <Img className="DV" src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_240/lsci/db/PICTURES/CMS/344700/344740.6.jpg"/>
                     <p style={{"color":"#2b2c2b","fontSize":"14px","fontWeight":"500","margin":"0px","paddingLeft":"5px"}}>Board grabs back his lost limelight</p>
                  </div>
                  <div className="LBIBPIMG">
                     <Img className="DV" src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_240/esci/media/motion/2022/0826/dm_220826_COM_CRIC_Analysis_PoliteEnquiries_Andersons_reverse_sweep_or_Leachs_reverse_sweep_220826/dm_220826_COM_CRIC_Analysis_PoliteEnquiries_Andersons_reverse_sweep_or_Leachs_reverse_sweep_220826.jpg"/>
                     <p style={{"color":"#2b2c2b","fontSize":"14px","fontWeight":"500","margin":"0px","paddingLeft":"5px"}}>Relif fro Foakers after timely ton reassures him of Test worth</p>
                  </div>
                </div>
              </div>
              <br/>
              <div className="Blog2">
                <div className="Blog21">
                 <div className="Blog211">
                  <p className="Blog21p1"><b>ICC MEDIA RIGHTS </b></p>
                  <p> </p>
                 </div>
                 
                </div>
                <div>
                <Img style={{"margin":"10px" ,"width":"95%","borderRadius":"10px"}} src="https://img1.hscicdn.com/image/upload/f_auto,t_ds_wide_w_320/lsci/db/PICTURES/CMS/308900/308967.8.jpg"/>
                  <p style={{"margin":"0px","paddingLeft":"5px"}}><b>Disney Star bags ICC media rights for Indian market</b></p>
                  <p style={{"margin":"0px","paddingLeft":"5px"}}>Winning bid includes rights to both TV and Digital offerings from 2024 to 2027</p>
                  <br />
                </div>
              </div>  
          </div>
      </div>
    )

}
export default CBlog